import { useLayoutEffect } from "react";

const TemporaryRedirect = ({ to }) => {
  useLayoutEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
};

export default TemporaryRedirect;
